var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClasseIiiHumide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ClasseIIIHumide_svg__a",
    d: "M5.333 5.333h53.333v53.333H5.333z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.576)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ClasseIIIHumide_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ClasseIIIHumide_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.333 12h29.334a4 4 0 014 4v29.333a4 4 0 01-4 4H17.333a4 4 0 01-4-4V16a4 4 0 014-4z",
    fill: "#FFB511",
    mask: "url(#ClasseIIIHumide_svg__b)",
    transform: "rotate(45 32 30.667)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0F1941",
    mask: "url(#ClasseIIIHumide_svg__b)",
    x: 20,
    y: 21.333,
    width: 24,
    height: 2.667,
    rx: 1.333
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0F1941",
    mask: "url(#ClasseIIIHumide_svg__b)",
    x: 20,
    y: 38.667,
    width: 24,
    height: 2.667,
    rx: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F1941",
    mask: "url(#ClasseIIIHumide_svg__b)",
    d: "M30.667 22.667h2.667v16h-2.667zm-6.667 0h2.667v16H24zm13.333 0H40v16h-2.667z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjUiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NSA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iZm1oNTlrdG5qYSIgZD0iTTUuMzMzIDUuMzMzaDUzLjMzM3Y1My4zMzNINS4zMzN6Ii8+CiAgICA8L2RlZnM+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSguNTc2KSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8bWFzayBpZD0iZ2l5dmt4cnAzYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2ZtaDU5a3RuamEiLz4KICAgICAgICA8L21hc2s+CiAgICAgICAgPHBhdGggZD0iTTE3LjMzMyAxMmgyOS4zMzRhNCA0IDAgMCAxIDQgNHYyOS4zMzNhNCA0IDAgMCAxLTQgNEgxNy4zMzNhNCA0IDAgMCAxLTQtNFYxNmE0IDQgMCAwIDEgNC00eiIgZmlsbD0iI0ZGQjUxMSIgbWFzaz0idXJsKCNnaXl2a3hycDNiKSIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMzIgMzAuNjY3KSIvPgogICAgICAgIDxyZWN0IGZpbGw9IiMwRjE5NDEiIG1hc2s9InVybCgjZ2l5dmt4cnAzYikiIHg9IjIwIiB5PSIyMS4zMzMiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyLjY2NyIgcng9IjEuMzMzIi8+CiAgICAgICAgPHJlY3QgZmlsbD0iIzBGMTk0MSIgbWFzaz0idXJsKCNnaXl2a3hycDNiKSIgeD0iMjAiIHk9IjM4LjY2NyIgd2lkdGg9IjI0IiBoZWlnaHQ9IjIuNjY3IiByeD0iMS4zMzMiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjMEYxOTQxIiBtYXNrPSJ1cmwoI2dpeXZreHJwM2IpIiBkPSJNMzAuNjY3IDIyLjY2N2gyLjY2N3YxNmgtMi42Njd6TTI0IDIyLjY2N2gyLjY2N3YxNkgyNHpNMzcuMzMzIDIyLjY2N0g0MHYxNmgtMi42Njd6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgClasseIiiHumide as ReactComponent };